/**
 * Toggle Switch Component - Simple checkbox style for easy interaction
 */
export function Toggle({ checked, onChange, label, hint, disabled = false }) {
  return (
    <label className={`flex items-start gap-3 select-none ${!disabled ? 'cursor-pointer hover:bg-slate-50 -mx-2 px-2 py-1.5 rounded-lg transition-colors' : 'opacity-50 cursor-not-allowed'}`}>
      <input 
        type="checkbox" 
        checked={checked} 
        onChange={onChange}
        disabled={disabled}
        className="mt-0.5 h-4 w-4 rounded border-slate-300 text-slate-900 focus:ring-2 focus:ring-slate-500 focus:ring-offset-0 cursor-pointer" 
      />
      <div className="flex-1">
        <div className="text-sm font-medium text-slate-700">{label}</div>
        {hint && <div className="text-xs text-slate-500 mt-0.5">{hint}</div>}
      </div>
    </label>
  );
}
